import React, { useEffect, useReducer } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { parseInt } from "lodash";
import { useSelector } from "react-redux";

import { getTheme } from "../../../common/highChartTheme";
import ophReducer from "../../../../reducers/oph";
import * as action from "../../../../actions/oph";
import moment from "moment";

const initialData = {
  ophAttainmentGraph: [],
};

const AttainmentGraph = (props) => {
  const colorsData = ["#56a9db", "#0286d6", "#7e929e"];
  const isLightMode = useSelector((state) => state.theme.lightMode);

  const [state, dispatch] = useReducer(ophReducer, initialData);
  const { refreshData } = useSelector((state) => state.ophDataRefresh);

  const { ophAttainmentGraph } = state;

  const { tierId, siteDate } = props;

  useEffect(() => {
    action.fetchOphAttainmentGraphData(dispatch, {
      tierId,
      startDate: moment(siteDate).format("YYYY-MM-DD"),
    });
  }, [refreshData]);

  const getGraphOptions = () => {
    const options = {
      chart: {
        type: "column",
      },
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
        },
      },
      tooltip: {
        shared: true,
      },
      series: [
        {
          name: "Missed",
          data:
            ophAttainmentGraph &&
            ophAttainmentGraph?.map((x) => {
              if (x.status !== "Not Started") {
                if (parseInt(x.target) >= parseInt(x.actual))
                  return [parseInt(x.target) - parseInt(x.actual)];
                else return [parseInt(x.actual)];
              }
            }),
          color: colorsData[0],
        },
        {
          name: "Actual",
          data:
            ophAttainmentGraph &&
            ophAttainmentGraph?.map((x) => {
              if (x.status !== "Not Started") {
                return [parseInt(x.actual)];
              }
            }),
          color: colorsData[1],
        },
        {
          name: "Not Started",
          data:
            ophAttainmentGraph &&
            ophAttainmentGraph?.map((x) => {
              if (
                x.status === "Not Started" &&
                x.status !== "Attained" &&
                x.status !== "Not Attained"
              ) {
                return [parseInt(x.target)];
              } else return [0];
            }),
          color: colorsData[2],
        },
      ],
    };
    return options;
  };

  return (
    <div
      style={{
        backgroundColor: isLightMode ? "#d3d3d3" : "#2a2a2a",
        padding: "20px 0px",
      }}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          ...getGraphOptions(),
          ...getTheme(
            "OPH Attainment",
            isLightMode,
            ophAttainmentGraph?.map((x) => x.hourNumber)
          ),
        }}
      />
    </div>
  );
};

export default React.memo(AttainmentGraph);
